// extracted by mini-css-extract-plugin
export default {"card":"DemoSection_card__wJiXI","spin":"DemoSection_spin__2BADS","success":"DemoSection_success__inu+g","show":"DemoSection_show__LDC3X"};